import Http from "../../common/utils/Http";

export const statementList = async () => {
    try {
        return await Http.get('home/content/privacySecurityStatement');
    } catch (error) {
        throw error;
    }
}
